import { SagaIterator } from "redux-saga";
import { call, put } from "redux-saga/effects";

import { AppsActions } from ".";
import { getAppsApi } from "./api";

export default function* apps(): SagaIterator {
  try {
    const response = yield call(getAppsApi);
    const { data } = response;
    yield put(AppsActions.success(data?.response));
  } catch (e) {
    yield put(AppsActions.error());
  }
}
